import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetDataForGreetingCardQueryVariables = Types.Exact<{
  ecardId: Types.Scalars['ID'];
}>;

export type GetDataForGreetingCardQuery = {
  __typename?: 'Query';
  getGreetingCardById?: { __typename?: 'GreetingCard'; id: string; type: string; theme: string; cardDetails: any; eventId: string } | null;
};

export type SaveGreetingCardAndEmailDraftMutationVariables = Types.Exact<{
  payload: Types.GreetingCardInputWithUrl;
}>;

export type SaveGreetingCardAndEmailDraftMutation = {
  __typename?: 'Mutation';
  saveGreetingCardAndEmailDraft?: { __typename?: 'PostOfficeGreetingCardEmailDraft'; id: string } | null;
};

export const GetDataForGreetingCardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDataForGreetingCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ecardId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGreetingCardById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ecardId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cardDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetDataForGreetingCardQuery__
 *
 * To run a query within a React component, call `useGetDataForGreetingCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForGreetingCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForGreetingCardQuery({
 *   variables: {
 *      ecardId: // value for 'ecardId'
 *   },
 * });
 */
export function useGetDataForGreetingCardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>) {
  return ApolloReactHooks.useQuery<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>(GetDataForGreetingCardDocument, baseOptions);
}
export function useGetDataForGreetingCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>(GetDataForGreetingCardDocument, baseOptions);
}
export type GetDataForGreetingCardQueryHookResult = ReturnType<typeof useGetDataForGreetingCardQuery>;
export type GetDataForGreetingCardLazyQueryHookResult = ReturnType<typeof useGetDataForGreetingCardLazyQuery>;
export type GetDataForGreetingCardQueryResult = Apollo.QueryResult<GetDataForGreetingCardQuery, GetDataForGreetingCardQueryVariables>;
export const SaveGreetingCardAndEmailDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveGreetingCardAndEmailDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GreetingCardInputWithUrl' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveGreetingCardAndEmailDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SaveGreetingCardAndEmailDraftMutationFn = Apollo.MutationFunction<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>;

/**
 * __useSaveGreetingCardAndEmailDraftMutation__
 *
 * To run a mutation, you first call `useSaveGreetingCardAndEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGreetingCardAndEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGreetingCardAndEmailDraftMutation, { data, loading, error }] = useSaveGreetingCardAndEmailDraftMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSaveGreetingCardAndEmailDraftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>(SaveGreetingCardAndEmailDraftDocument, baseOptions);
}
export type SaveGreetingCardAndEmailDraftMutationHookResult = ReturnType<typeof useSaveGreetingCardAndEmailDraftMutation>;
export type SaveGreetingCardAndEmailDraftMutationResult = Apollo.MutationResult<SaveGreetingCardAndEmailDraftMutation>;
export type SaveGreetingCardAndEmailDraftMutationOptions = Apollo.BaseMutationOptions<SaveGreetingCardAndEmailDraftMutation, SaveGreetingCardAndEmailDraftMutationVariables>;
